import type { StreamStatus } from "..";
import { GameLaunchStatus } from "../constants/webrtc";

export const shouldSimulateMouseEvents = (
  streamStatus?: StreamStatus,
): boolean => {
  if (!streamStatus?.status) return false;
  const statusValues = Object.values(GameLaunchStatus);
  const currentIndex = statusValues.indexOf(streamStatus.status);
  const launchingIndex = statusValues.indexOf(
    GameLaunchStatus.STATUS_GAMERUNNING,
  );
  return currentIndex !== -1 && currentIndex < launchingIndex;
};

/**
 * True while the game itself has not started yet - launcher, Steam login, EULA
 * and option screens.
 */
const GAME_RUNNING_STATUSES: GameLaunchStatus[] = [
  GameLaunchStatus.STATUS_GAMERUNNING,
  GameLaunchStatus.STATUS_GAMERUNNING_DISCONNECTED,
  GameLaunchStatus.STATUS_GAMERUNNING_UPDATEPENDING,
];

export const isBeforeGameRunning = (
  status?: GameLaunchStatus | null,
): boolean => {
  if (!status) return false;
  if (GAME_RUNNING_STATUSES.includes(status)) return false;

  const statusValues = Object.values(GameLaunchStatus);
  const currentIndex = statusValues.indexOf(status);
  const runningIndex = statusValues.indexOf(
    GameLaunchStatus.STATUS_GAMERUNNING,
  );
  return currentIndex !== -1 && currentIndex < runningIndex;
};
